/* Faq Module */

angular.module('jrSupport', ['jrConfig', 'jrAutocompleteEmail']);
